import React from "react"
import cx from "classnames"
import Styles from "@/components/core/Radio/Radio.module.scss"

const Radio = props => (
  <div className={Styles.radioButtonWrapper}>
    <label
      aria-checked={props.checked}
      tabIndex={props.tabIndex ?? 0}
      role={props.role ?? "radio"}
      aria-label={props.ariaLabel ?? props.label}
      className={cx({
        "radio-button": true,
        "--black": props.type === "black",
        "--disabled": props.disabled ?? false,
      })}
    >
      <input
        type="radio"
        name={props.name}
        value={props.value}
        onClick={e => props.onSelect(e)}
        defaultChecked={props.checked}
        disabled={props.disabled}
      />
      <div className="radio-button__marker">
        <div className="radio-button__checked" />
      </div>
      <span className="radio-button__label">{props.label}</span>
    </label>
  </div>
)

export default Radio
